var Program = (function () {
    function Program() {
        this.isRandom = false;
        this.contextID = "";
    }
    Program.fromJson = function (data) {
        var p = new Program;
        p._id = data._id;
        p.title = data.title || "";
        p.exerciseIds = data.exerciseIds || [];
        return p;
    };
    return Program;
}());
export { Program };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Program.ts.pre-build-optimizer.js